import React, {
  forwardRef,
  useImperativeHandle,
  useState,
} from 'react';
import classNames from 'classnames';
import ModalHeader from '../ModalHeader';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import styles from './styles.module.scss';

interface Tab {
  id: string;
  label: string;
  icon: string;
  content: React.ReactNode;
  disabled?: boolean;
  warning?: boolean;
}

interface VerticalTabsProps {
  headerContent?: React.ReactNode;
  tabs?: Tab[];
}

export interface VerticalTabsRef {
  setActiveTab: (id: string) => void;
}

const VerticalTabs = forwardRef<VerticalTabsRef, VerticalTabsProps>(
  ({
     headerContent = null,
     tabs = [],
   }, ref) => {
    const [activeTab, setActiveTab] = useState(tabs[0]?.id);

    useImperativeHandle(ref, () => ({
      setActiveTab,
    }));

    const current = tabs.find(t => t.id === activeTab);

    const handleTabClick = (tab: Tab) => {
      if (tab.disabled) return;

      setActiveTab(tab.id);
    };

    return (
      <div className={styles.container}>
        <div className={styles.sidebar}>
          {headerContent}

          {tabs.map(tab => (
            <button
              key={tab.id}
              className={classNames(
                styles.tab,
                activeTab === tab.id && styles.active,
                tab.disabled && styles.disabled
              )}
              onClick={() => handleTabClick(tab)}
              disabled={tab.disabled}
            >
              <img
                className={styles.icon}
                src={toAbsoluteUrl(tab.icon)}
                alt="i"
              />
              <span>{tab.label}</span>
              {tab.warning &&
                <img
                  className={styles.warning}
                  src={toAbsoluteUrl('/media/common/Warning_circle_red.svg')}
                  alt="i"
                />
              }
            </button>
          ))}
        </div>

        <div className={styles.content}>
          <ModalHeader
            header={current?.label}
            customClassnames="p-4"
          />
          {current?.content}
        </div>
      </div>
    );
  }
);

export default VerticalTabs;